import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
/**
 * cachedElement的rootDom的id前缀
 */
export const CACHED_ELEMENT_PREFIX = 'ca';

/**
 * 同步或者异步渲染的高阶组件的id标识
 */
export const elementHocType = {
    ELEMENT_HOC: 'el',
    ASYNC_HOC: 'as',
};

export const TEXT_PREFIX = 'editor-lite';

/**
 *  根据Hoc类型和elementId等信息来生成cachedElement的
 * @param elementHocType
 * @param elementModelKey elementModel的key值
 * @param extra 其他字段信息
 */
export function domIdOfCachedElement(elementHocType: string, elementModelKey: any, extra: any) {
    return `${CACHED_ELEMENT_PREFIX}::${elementHocType}${elementModelKey ? `::${elementModelKey}` : ''}${extra ? `::${extra}` : ''}`;
}

/**
 *
 * @param elementKeyStack
 * @param slideModel
 */
export function elementModelOfKeyStack(elementKeyStack, slideModel) {
    let currentModel = slideModel;
    for (let i = elementKeyStack.length - 1; i >= 0; i--) {
        const currentKey = elementKeyStack[i];
        for (let j = 0; currentModel.children && j < currentModel.children.length; j++) {
            if (/* currentModel.children[j] instanceof ElementBaseModel
                && */currentKey === currentModel.children[j].key) {
                if (currentModel.type === UIModelType.SHAPE && currentModel.inTable) {
                    // 表格内的
                    continue;
                }
                currentModel = currentModel.children[j]; // 当前的key已经找到，跳出循环
                break;
            }
        }
    }
    if (currentModel === slideModel) {
        return null;
    }
    return currentModel;
}


/**
 * 根据传入的dom找到所属的elementModel以及是否需要立即重建
 * @param endDomId
 * @param dom
 * @param slideModel
 */
export function findElementsFromDom(endDomId: string, dom, slideModel) {
    let isFind: boolean;
    let isInText: boolean;
    let node: any;
    let elementModel;
    const cachedElementKeys: string[] = [];
    isFind = false;
    isInText = false;
    node = dom;
    const elementKeyStack: string[] = [];
    while (node && node.id !== endDomId) { // 结束domId
        if (!isInText
            && node.id && node.id.startsWith(TEXT_PREFIX)) { // 表示查找到了文本框
            isInText = true;
        }
        if (node.id?.startsWith(CACHED_ELEMENT_PREFIX)) { // 表示遇到了cachedElement
            cachedElementKeys.push(node.id);
            const segments = node.id.split('::');
            if (segments[1] === elementHocType.ELEMENT_HOC) { // 表示找到了element或者是rootElement
                if (segments[2]) { // 表示第三个字段有数据，里面有elementId或者其他key值
                    elementKeyStack.push(segments[2]);
                }
                elementModel = elementModelOfKeyStack(elementKeyStack, slideModel);
                isFind = true;
                break;
            } else {
                elementKeyStack.push(segments[2]);
            }
        }
        node = node.parentNode;
    }
    return {
        isFind,
        isInText,
        elementModel,
        cachedElementKeys,
    };
}
